export const SEARCH_HISTORY_KEY = 'keywords'; // 此处与旧版维持一致

const getStorageKey = (key) => `wps_academy_storage_${key}`;

export const USERINFO_KEY = getStorageKey('userInfo');
export const FEEDBACK_SUBMITED_KEY = getStorageKey('feedbackSubmited');
export const IS_HELP_FEEDBACK_KEY = getStorageKey('isHelpFeedback');
export const VIDEO_BOTTOM_BANNER_KEY = getStorageKey('videobottombanner');
export const VIDEO_RIGHT_BANNER_KEY = getStorageKey('videorightbanner');
export const VIDEO_AUTO_PALY_KEY = getStorageKey('videoAutoPaly');
